import { useQuery } from "@tanstack/react-query";
import { FileResponse, getFilesAndFolders } from "./sharepointApi";
import { queryKeys } from "../queryKeys";

export function useGetFilesAndFolders() {
    return useQuery<FileResponse[]>({ ...queryKeys.sharepointFilesAndFolders.all, queryFn: getFilesAndFolders });
}
